import { h } from 'preact';

export default props => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M15 12.5L10 7.5L5 12.5" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);